// Б.2.b: Пропаганда в баре (syn_propaganda_v_bare, action, legendary, init=4).
//
// Без picker'а.
//
// Эффект:
//   1. Призывает 4 юнитов на стороне игрока:
//      • Торчок №1 → 1-я линия
//      • Торчок №2 → 2-я линия
//      • Вышибала №1 → 1-я линия
//      • Вышибала №2 → 1-я линия
//   2. Если конкретная линия для конкретного призыва занята полностью (4 юнита) —
//      этот конкретный призыв пропускается, остальные идут.
//   3. Каждый успешно призванный юнит получает:
//      • +1/1/0 (текущая атака +1, текущая броня +1) до конца игры.
//      • Один случайный Мод Синтетикса через стандартный attachMod.
//   4. Призванные юниты ИГНОРИРУЮТ Initiation Cooldown — активируются мгновенно
//      (initiation = 0 на инстансе) и атакуют в Ф3 этого же хода.
//   5. Триггер Бишора срабатывает за каждый Мод, повешенный на призванного.

import { Card } from '../../card.js';
import { attachMod } from './modifications.js';
import { onUnitSummoned } from '../deus/hooks.js';
import { fireSyntheticOnSpawnPassive } from '../deus/index.js';
import { cards as cardsSyn } from '../../../data/cards-syntetics.js';

export const CARD_ID = 'syn_propaganda_v_bare';

const SUMMONS = [
  { id: 'syn_torchok',   line: 0 },
  { id: 'syn_torchok',   line: 1 },
  { id: 'syn_vyshibala', line: 0 },
  { id: 'syn_vyshibala', line: 0 }
];

function findFreeSlot(player, line) {
  for (let s = 0; s < 4; s++) {
    if (player.field[line][s] === null) return s;
  }
  return -1;
}

function modPool() {
  return cardsSyn.filter(c => c.type === 'mod');
}

export function resolvePropaganda(state, playerIdx) {
  const me = state.players[playerIdx];
  const pool = modPool();
  state.log.add(`🍺 ${me.name}: Пропаганда в баре — призыв 2 Торчков и 2 Вышибал`);

  for (const desc of SUMMONS) {
    const slot = findFreeSlot(me, desc.line);
    if (slot < 0) {
      state.log.add(`🍺 Пропаганда: ${desc.id} — ${desc.line === 0 ? '1-я' : '2-я'} линия занята, призыв пропущен`);
      continue;
    }
    const tpl = cardsSyn.find(c => c.id === desc.id);
    if (!tpl) continue;
    const summon = new Card(tpl);
    summon.ownerId = playerIdx;
    summon.initiation = 0;          // игнорируем Cooldown — активны мгновенно
    summon.placedTurn = state.currentTurn;
    summon.revealed = true;         // уже на поле, в Ф3 не «вскрывается заново»
    summon.activated = false;       // лог активации taunt сработает в Ф3
    // +1/+1/0 до конца игры.
    summon.current.atk   += 1;
    summon.current.armor += 1;
    summon.persistentArmor    = (summon.persistentArmor    || 0) + 1;
    summon.persistentMaxArmor = (summon.persistentMaxArmor || 0) + 1;
    me.placeCard(summon, desc.line, slot);
    state.log.add(
      `🍺 Пропаганда: ${summon.name_ru} → ${desc.line === 0 ? '1-я' : '2-я'} линия / слот ${slot + 1} ` +
      `(+1/+1/0)`
    );
    // Триггеры появления союзника (Бишор, Раст-passive, Ликвидатор-эксперт, Аура,
    // Списанный дрон override). Через стандартный диспетчер.
    onUnitSummoned(state, playerIdx, summon);
    // Spawn-passive (Личный телохранитель, Инициатор) — Торчок/Вышибала их не имеют,
    // но через диспетчер на будущее.
    if (!summon.spawnPassiveFired) {
      fireSyntheticOnSpawnPassive(state, playerIdx, summon);
      summon.spawnPassiveFired = true;
    }
    // Случайный Мод. Без isPlayed — это эффект Действия, не «розыгрыш Мода с руки».
    if (pool.length > 0 && summon.isAlive()) {
      const tplMod = pool[state.rng.int(pool.length)];
      attachMod(state, summon, { id: tplMod.id, name_ru: tplMod.name_ru }, {
        cardId: CARD_ID, ownerIdx: playerIdx
      });
    }
  }
  return { ok: true };
}
